import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_InitialChargeParametersFormMeta {
    initialTotalAmount: FormInputMeta;
    source: FormInputMeta;
    
}

const initialChargeParametersFormMeta = {} as I_InitialChargeParametersFormMeta;

initialChargeParametersFormMeta.initialTotalAmount = {
    name: "initialTotalAmount",
    type: "number",
    label: "Montant Total Inital",
    placeholder: "",
    validation: yup.number()
};

initialChargeParametersFormMeta.source = {
    name: "source",
    type: "select",
    label: "Source",
    placeholder: "",
    validation: yup.string()
};

export default initialChargeParametersFormMeta;